import { Component, inject, ChangeDetectionStrategy } from '@angular/core';


import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogActions, MatDialogContent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

import { StateService } from '../shared/state.service';
import * as dao from '../shared/dao';
import { FormatFSECurrencyPipe } from '../shared/format-currency.pipe';

export interface DialogData {
	factureFR: dao.FactureFR;
	codeALD: boolean;
}

// Codes prestations soumis à un plafond C2S (audio + optique) — affichage d'une input box plafond
const PLAFOND_C2S_CODES = new Set(['P2D', 'P2G', 'P2B', 'P2H', 'P2J', 'V01', 'V02', 'V03', 'V04', 'M01', 'M02']); // TODO duplicates prestations static property

@Component({
	selector: 'lib-validate-ald-prestations',
	standalone: true,
	imports: [FormsModule, MatDialogModule, MatDialogContent, MatDialogActions, MatButtonModule, MatButtonToggleModule, MatTooltipModule, FormatFSECurrencyPipe],
	templateUrl: './validateAldPrestations.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['../bs-dialog/bs-dialog.component.scss', './validateAldPrestations.component.scss'],
})
export class ValidateAldPrestationsComponent {
	readonly dialogRef = inject(MatDialogRef<ValidateAldPrestationsComponent>);
	readonly dialogdata = inject(MAT_DIALOG_DATA) as DialogData;
	isOnePlafondC2S: boolean = false;	// Is there at least one prestation (plafond C2S)

	constructor(public stateService: StateService) {}

	ngOnInit() {
		// Amount/date conversions are already applied by PrestationsComponent (this dialog is opened on top of it
		// and shares the same factureFR by reference) — re-applying them here would double-divide the amounts.
		this.dialogdata.factureFR.prestationFR.forEach((prestation: dao.PrestationFR) => {
			this.isOnePlafondC2S = this.isOnePlafondC2S || this.isPlafondC2S(prestation);
		});
		// Reset codeJustifETM on the NEXT tick: PrestationsComponent shares these PrestationFR objects by reference,
		// and mutating them synchronously here would change a value the parent has already bound during the current
		// change detection cycle → NG0100 ExpressionChangedAfterItHasBeenCheckedError.
		setTimeout(() => {
			this.dialogdata.factureFR.prestationFR.forEach((prestation: dao.PrestationFR) => {
				prestation.codeJustifETM = '';	// Force the user to make an explicit ALD choice for each prestation
			});
		});
	}

	canValidate(): boolean {
		return this.dialogdata.factureFR.prestationFR.every(
			(line: dao.PrestationFR) => line.codeJustifETM !== undefined && line.codeJustifETM !== ''
		);
	}

	onValidate() {
		// Values are shared with PrestationsComponent through dialogdata.factureFR by reference,
		// so closing this dialog is enough to feed the changes back.
		this.dialogRef.close();
	}

	onChangeAMCAmount(line: dao.PrestationFR) {
		line.forcageAMC = true;
	}

	public isPlafondC2S(line: dao.PrestationFR): boolean {	// Code presta dans la liste des plafonds C2S (audio + optique)
		return !!line.codePresta && PLAFOND_C2S_CODES.has(line.codePresta);
	}
}
